import {Component, OnInit, ViewChild} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {AuthService} from "../service/auth.service";
import {UserService} from "../service/user.service";
import {EUserType} from "../enums/EUserType";
import {UtilsService} from "../service/utils.service";
import {IUser} from "../interfaces/IUser";
import {Menubar} from "primeng/menubar";
import {Menu} from "primeng/menu";

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styles: [`
        :host ::ng-deep .p-submenu-list {
            width: auto !important;
            min-width: 150px;
        }
    `]
})
export class AppTopBarComponent implements OnInit {
    EUserType = EUserType;
    items!: MenuItem[];
    AdminItems!: MenuItem[];
    RootItems!: MenuItem[];
    UserItems!: MenuItem[];
    ManagerItems!: MenuItem[];
    OperatorItems!: MenuItem[];
    userItems!: MenuItem[];
    Dashboard: MenuItem = {
        label: 'Dashboard',
        icon: 'pi pi-home',
        items: [
            {
                label: 'Root',
                icon: 'pi pi-user',
                routerLink: ['/root-dashboard'],
            },
            {
                label: 'Admin',
                icon: 'pi pi-user',
                routerLink: ['/admin-dashboard'],
            },
        ]
    };
    Masters: MenuItem = {
        label: 'Masters',
        icon: 'pi pi-sitemap',
        items: [
            {
                label: 'Customers',
                icon: 'pi pi-user',
                routerLink: ['/customers'],
            },
            {
                label: 'Customers View',
                icon: 'pi pi-book',
                routerLink: ['/customers-view'],
            },
            {
                label: 'User',
                icon: 'pi pi-users',
                routerLink: ['/users'],
            },
        ]
    };

    user: IUser = <any>{}


    // @ts-ignore
    @ViewChild('editProfileFormModal') editProfileFormModal: EditUserProfileComponent;
    @ViewChild('rootMenuBar') rootMenuBar: Menubar;
    @ViewChild('rootMenuBarUserMenu') rootMenuBarUserMenu: Menu;

    @ViewChild('adminMenuBar') adminMenuBar: Menubar;
    @ViewChild('adminMenuBarUserMenu') adminMenuBarUserMenu: Menu;

    @ViewChild('userMenuBar') userMenuBar: Menubar;
    @ViewChild('userMenuBarUserMenu') userMenuBarUserMenu: Menu;

    @ViewChild('ccMenuBar') ccMenuBar: Menubar;
    @ViewChild('ccMenuBarUserMenu') ccMenuBarUserMenu: Menu;

    @ViewChild('sponsorMenuBar') sponsorMenuBar: Menubar;
    @ViewChild('sponsorMenuBarUserMenu') sponsorMenuBarUserMenu: Menu;

    constructor(
        public userService: UserService,
        public utilsService: UtilsService,
        private authService: AuthService,) {
        let isMenuHidden = false;
        setInterval(() => {
            if (document.activeElement.tagName === 'IFRAME') {
                if (!isMenuHidden) {
                    isMenuHidden = true;
                    if (this.user.usr_type_str === EUserType.ROOT) {
                        this.rootMenuBar.hide();
                        this.rootMenuBarUserMenu.hide();
                    } else if (this.user.usr_type_str === EUserType.ADMIN) {
                        this.adminMenuBar.hide();
                        this.adminMenuBarUserMenu.hide();
                    } else if (this.user.usr_type_str === EUserType.MANAGER) {
                        this.adminMenuBar.hide();
                        this.adminMenuBarUserMenu.hide();
                    } else if (this.user.usr_type_str === EUserType.OPERATOR) {
                        this.adminMenuBar.hide();
                        this.adminMenuBarUserMenu.hide();
                    } else if (this.user.usr_type_str === EUserType.USER) {
                        this.userMenuBar.hide();
                        this.userMenuBarUserMenu.hide();
                    }
                }
            } else isMenuHidden = false;
        }, 300);
    }

    ngOnInit() {
        this.setMenuAsUser();
        this.AdminItems = [
            this.Dashboard,
            this.Masters,
            // this.Approvals,
        ];
        this.RootItems = [
            this.Dashboard,
            this.Masters,
            // this.Approvals,
        ];
        this.UserItems = [
            this.Dashboard,
            this.Masters,
            // this.Approvals,
        ];
        this.ManagerItems = [
            this.Dashboard,
            this.Masters,
            // this.Approvals,
        ];
        this.OperatorItems = [
            this.Dashboard,
            this.Masters,
            // this.Approvals,
        ];

        this.userItems = [
            {
                label: "👋" + " " + "Hello," + " " + this.authService.gUser?.usr_first_name_str + "!",
                styleClass: 'pointer-events-none bg-no-repeat',
            },
            {
                separator: true
            },
            {
                label: 'Change PIN',
                icon: 'pi pi-fw pi-user ml-1',
                command: () => this.editProfileFormModal.userDialog(),
            },
            {
                label: 'Logout',
                icon: 'pi pi-fw pi-sign-out ml-1',
                command: () => this.authService.logout()
            }
        ];

    }

    setMenuAsUser() {
        this.user = this.authService.gUser;
        if (this.user.usr_type_str === EUserType.ADMIN) {
        }
        if (this.user.usr_type_str === EUserType.MANAGER) {
        }
        if (this.user.usr_type_str === EUserType.OPERATOR) {
        }
        if (this.user.usr_type_str === EUserType.USER) {
            // delete this.Dashboard.items[0];
            // delete this.Dashboard.items[1];
            // delete this.Dashboard.items[2];
            // delete this.Dashboard.items[3];
            // delete this.Dashboard.items[4];
        }
    }
}
